import { useState, useEffect } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import { Dialog, DialogActions, DialogContent,DialogContentText, DialogTitle, Button, Box, TextField, MenuItem } from '@mui/material';
import { DataGrid, itIT, GridToolbar, useGridApiRef } from '@mui/x-data-grid';		//https://mui.com/x/react-data-grid/ [MIT version]
import MoveDownIcon from '@mui/icons-material/MoveDown';
import ContentPasteOffIcon from '@mui/icons-material/ContentPasteOff';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import InfoIcon from '@mui/icons-material/Info';
import moment from 'moment';
import ActionButton from "../Components/ActionButton.js";
import ContactsIcon from '@mui/icons-material/Contacts';
import PhoneIcon from '@mui/icons-material/Phone';
import AnnotationForm from "../Components/Annotation/AnnotationForm";
import Functions from "../Services/Functions";

import Api from '../Services/Api';
import {PAGE_SIZE, pageSizeOptions} from '../Config/constants.js';

import { extTimeTableIntervals as optionsTimeTableIntervals, colorDataBackground } from '../Config/constants.js';

function Timetable(props) {
	const apiRef = useGridApiRef();	//https://mui.com/x/api/data-grid/
	const DEFAULT_VALUE = "60";

	const deadlineTypes = {
		//Keep updated in app\Http\Controllers\AppointmentController.php
		ANN: 'Annotazione cliente',
		REP: 'Ritorno su riparazione',
		DEA_P: 'Prova fumi',
		DEA_M: 'Manutenzione',
        PC: 'Chiamata al cliente',
	};

	const [rows, setRows] = useState([]);

    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: localStorage.getItem('timetable_record_per_page') ? parseInt(localStorage.getItem('timetable_record_per_page')) : PAGE_SIZE,
    });

    const [filters, setFilters] = useState({
        city: localStorage.getItem('timetable_filter_city') ?? '',
        area: localStorage.getItem('timetable_filter_area') ?? '',
        vType: localStorage.getItem('timetable_filter_vType') ?? '',
        options: {
            city: [],
            area: [],
            vType: Object.values(deadlineTypes)
        }
    });
    const [filterFutureOnly, setFilterFutureOnly] = useState(localStorage.getItem('timetable_filter_futureOnly') ?? 'NO');

	const [lastUpdate, setLastUpdate] = useState([]);
	const [displayDialog, setDisplayDialog] = useState(0);
	const [displayDialogContent, setDisplayDialogContent] = useState(null);
	const [displayManagementDialogId, setDisplayManagementDialogId] = useState(null);
	const [days, setDays] = useState(DEFAULT_VALUE);
	const [fromDay, setFromDay] = useState(null);
	const [toDay, setToDay] = useState(null);

    const ColorClasses = () => {
        const generatedClasses = colorDataBackground.map((color) => {
            const className = color.name.toLowerCase(); // Convert name to lowercase for class name
            const backgroundColor = color.hex;

            return `.${className} {
                background-color: ${backgroundColor};
            }`;
        });

        return (
            <div className="color-classes-container">
                <style>{generatedClasses.join('\n')}</style>
            </div>
        );
    };

	useEffect(() => {
		try {
			Api.get({endpoint: `timetable/lists/${days}`, contentType : 'application/json'})
			.then(response => {
				setRows(response.data.items);
                setFilters(prev => ({
                    ...prev,
                    options: {
                        ...prev.options,
                        city: response.data.cities,
                        area: response.data.area,
                    }
                }));
				setFromDay(moment(response.data.from).format('DD/MM/YYYY'));
				setToDay(moment(response.data.to).format('DD/MM/YYYY'));
			})
			.catch(error => {
					setDisplayDialog(-1);
			});
		} catch (error) {
			setDisplayDialog(-1);
		}
	}, [lastUpdate, days]);	// eslint-disable-line react-hooks/exhaustive-deps

	const handleClose = () => {
		setDisplayDialog(0);
	};

    function retrieveTipology(row) {
        let tipology = "";

        if (row.tipology) {
            if (row.tipology === "DEA") {
                tipology = row.details;
            }
            else {
                if (row.tipology === "ANN" && row.isPhoneCall) {
                    tipology = deadlineTypes["PC"];
                }
                else {
                    tipology = deadlineTypes[row.tipology];
                }
            }
        }

        return tipology;
    }

	function arrayIntervalsResponse() {
		return (
			optionsTimeTableIntervals.map((interval) => (
				<MenuItem key={interval} value={interval}>
					{`${interval} giorni (${Math.round(interval/30)} mesi)`}
				</MenuItem>
			))
		);
	}

    function arrayOthersResponse(source, label) {
        return [
            <MenuItem key="" value="">
                {label}
            </MenuItem>,
            ...source.map((comboElement) => (
                <MenuItem key={comboElement} value={comboElement}>
                    {comboElement}
                </MenuItem>
            ))
        ];
    }

    const handlePaginationChange = (newModel) => {
        setPaginationModel(newModel);
        localStorage.setItem('timetable_record_per_page', newModel.pageSize);
    };

	function extraFilter(selectedValue) {
		setDays(selectedValue);
	}

    function extraFilterOther(selectedValue, filterKey) {
        localStorage.setItem('timetable_filter_' + filterKey, selectedValue);
        setFilters(prev => ({
            ...prev,
            [filterKey]: selectedValue
        }));
    }

    function extraFilterFutureOnly(selectedValue) {
        localStorage.setItem('timetable_filter_futureOnly', selectedValue);
        setFilterFutureOnly(selectedValue);
    }

    function handleCloseManagementDialog() {
        setDisplayManagementDialogId(null);
        setLastUpdate(Date.now());
    }

	function handleManaged(expiration, extraData) {
        if (!window.confirm("Confermi di aver gestito manualmente questa scadenza?"))
            return;
        setDisplayManagementDialogId({
            'expiration': expiration,
            'extraData': extraData,
        });
	}

	function handlePhoned(expiration, extraData) {
        if (!window.confirm("Hai chiamato il cliente?\nQuesto non imposterà come Gestita la scadenza che quindi rimarrà in scadenziario.\nContinuare?"))
            return;
        setDisplayManagementDialogId({
            'expiration': expiration,
            'extraData': extraData,
            'isPhoneCall': true
        });
	}

	function handleDisabled(expiration) {
		try {
			if (!window.confirm("Chiudendo l'impianto non si otterranno più notifiche su di esso\nnello scadenziario. Proseguire?"))
				return;

			Api.get({endpoint: `timetable/setDisabled/${expiration}`, contentType : 'application/json'})
				.then(response => {
					setDisplayDialogContent(null);
					setDisplayDialog(1);
					setLastUpdate(Date.now());
				})
				.catch(error => {
							setDisplayDialog(-1);
				});
		} catch (error) {
			setDisplayDialog(-1);
		}
	}


	const columns = [
		{
			field: 'customer',
			headerName: 'Cliente',
			flex: 1,
		},
		{
			field: 'phone',
			headerName: 'Telefono',
			flex: 0.5,
		},
		{
			field: 'city',
			headerName: 'Comune',
			flex: 0.5,
		},
		{
			field: 'area',
			headerName: 'Provincia',
			flex: 0.3,
		},
		{
            field: 'eventDate',
            headerName: 'Scadenza',
            flex: 0.5,
            type: 'date',
            valueGetter: (params) => params.row?.eventDate ? new Date(params.row.eventDate) : null,
            valueFormatter: (params) => {
                if (!params.value) return ''; // evita errori se nullo
                const date = new Date(params.value);
                return date.toLocaleDateString('it-IT');
            }
		},
		{
            field: 'lastCall',
            headerName: 'Chiamato il',
            flex: 0.5,
            type: 'date',
            valueGetter: (params) => params.row?.lastCall ? new Date(params.row.lastCall) : null,
            valueFormatter: (params) => {
                if (!params.value) return ''; // evita errori se nullo
                const date = new Date(params.value);
                return date.toLocaleDateString('it-IT');
            }
		},
		{
			field: 'tipology',
			headerName: 'Tipologia',
			flex: 0.5,
			valueGetter: (params) => {
				return retrieveTipology(params.row);
			},
		},
		{
			field: 'managed',
			headerName: 'Gestita',
			type: 'boolean',
			valueGetter: (params) => {
				return params.row.managed ? true : false
			},
		},
		{
			field: 'id',
			headerName: 'Azioni',
			flex: 1,
			renderCell: (params) => {
				function onShow(e) {
					e.stopPropagation(); // don't select this row after clicking
					let extraData = apiRef.current.getCellValue(params.value, 'extra_data');
					setDisplayDialogContent(Functions.explodeExtraData(extraData));
					setDisplayDialog(1);
				};
                function onPhone(e) {
                    let extraData = apiRef.current.getCellValue(params.value, 'extra_data');
					handlePhoned(params.value, extraData);
                }
				function onAppointment(e) {
                    window.open(`appointments/createFromExpire/${params.value}`,'_blank');
					//navigate(`../appointments/createFromExpire/${params.value}`);
				}
				function onCustomer(e) {
                    let extraData = JSON.parse(params.row.extra_data);
                    window.open(`customers/edit/${extraData.customer_id}`,'_blank');
					//navigate(`../customers/edit/${extraData.customer_id}`);
				}
				function onManaged(e) {
                    let extraData = apiRef.current.getCellValue(params.value, 'extra_data');
					handleManaged(params.value, extraData);
				}
				function onDisabled(e) {
					handleDisabled(params.value);
				}
				return <>
					<ActionButton title={"Visualizza scheda Cliente"} disabled={!apiRef.current.getCellValue(params.value, 'extra_data')} onClick={onCustomer}>
						<ContactsIcon />
					</ActionButton>
                    <ActionButton title={"Visualizza dettagli Scadenza"} disabled={!apiRef.current.getCellValue(params.value, 'extra_data')} onClick={onShow}>
						<InfoIcon />
					</ActionButton>
					<ActionButton title={"Segnala chiamata effettuata"} disabled={apiRef.current.getCellValue(params.value, 'tipology') !== deadlineTypes['DEA_P'] && apiRef.current.getCellValue(params.value, 'tipology') !== deadlineTypes['DEA_M']} badgeValue={apiRef.current.getCellValue(params.value, 'numberOfCalls')} onClick={onPhone}>
						<PhoneIcon />
					</ActionButton>
					<ActionButton title={"Converti in appuntamento"} disabled={apiRef.current.getCellValue(params.value, 'tipology') === deadlineTypes['ANN'] || apiRef.current.getCellValue(params.value, 'managed')} onClick={onAppointment}>
						<MoveDownIcon />
					</ActionButton>
					<ActionButton title={"Segnala come gestita"} disabled={apiRef.current.getCellValue(params.value, 'managed')} onClick={onManaged}>
						<CheckCircleOutlineIcon />
					</ActionButton>
					<ActionButton title={"Impianto non più attivo"} disabled={apiRef.current.getCellValue(params.value, 'tipology') === deadlineTypes['ANN'] || apiRef.current.getCellValue(params.value, 'managed')} onClick={onDisabled}>
						<ContentPasteOffIcon />
					</ActionButton>
				</>
			}
		},
	]

	const theme = createTheme({
			palette: {
				primary: { main: '#11cb5f' },
			},
		},
		itIT,
	);

    const filteredRows = rows.filter((row) => {
        const { city, area, vType } = filters;
        const baseMatch =
            (!city || row.city === city) &&
            (!area || row.area === area) &&
            (!vType || retrieveTipology(row) === vType);
        if (filterFutureOnly === 'SI') {
            const rowDate = moment(row.eventDate, 'YYYY-MM-DD');
            const thresholdDate = moment(fromDay, 'DD/MM/YYYY');
            return baseMatch && rowDate.isSameOrAfter(thresholdDate);
        }
        return baseMatch;
    });

	return (
		<>
            <ColorClasses />
			<h5>Scadenziario</h5>
			<div className="row styled">
				<div className="col-md-2">
					<TextField
						fullWidth
						label="Intervallo di visualizzazione"
						name="interval"
						className="styled"
						select
						defaultValue = {DEFAULT_VALUE}
						InputProps={{
							style: {color: theme.palette.primary.darkMain}
						}}
						onChange={(e) => {
							extraFilter(e.target.value);
						}}
					>
						{arrayIntervalsResponse()}
					</TextField>
				</div>
				<div className="col-md-10">
					<p style={{fontSize: '0.8em'}}>
						{fromDay && toDay && (
							<span>Dal: {fromDay}* - Al: {toDay}</span>
						)}
						<br />
						* Vengono visualizzate anche le scadenze (gestite) degli ultimi 5 giorni - Le scadenze NON GESTITE nel passato sono invece sempre tutte visibili<br />
						Per gli impianti 'chiusi' non vengono visualizzate solo le scadenze relative a Prova fumi/Manutenzione
					</p>
				</div>
			</div>

            <div className="row styled">
				<div className="col-md-2">
					<TextField
						fullWidth
						label="Comune"
						name="city"
						className="styled"
						select
						InputProps={{
							style: {color: theme.palette.primary.darkMain}
						}}
                        value={filters.city}
                        onChange={(e) => extraFilterOther(e.target.value, 'city')}
					>
						{arrayOthersResponse(filters.options.city || [""], "-- Tutti i comuni --")}
					</TextField>
				</div>
				<div className="col-md-2">
					<TextField
						fullWidth
						label="Provincia"
						name="area"
						className="styled"
						select
						InputProps={{
							style: {color: theme.palette.primary.darkMain}
						}}
                        value={filters.area}
                        onChange={(e) => extraFilterOther(e.target.value, 'area')}
					>
						{arrayOthersResponse(filters.options.area || [""], "-- Tutte le province --")}
					</TextField>
				</div>
				<div className="col-md-2">
					<TextField
						fullWidth
						label="Tipologia"
						name="vType"
						className="styled"
						select
						InputProps={{
							style: {color: theme.palette.primary.darkMain}
						}}
                        value={filters.vType}
                        onChange={(e) => extraFilterOther(e.target.value, 'vType')}
					>
						{arrayOthersResponse(filters.options.vType || [""], "-- Tutte le tipologie --")}
					</TextField>
				</div>
				<div className="col-md-2">
					<TextField
						fullWidth
						label="Nascondi scadenze vecchie"
						name="vType"
						className="styled"
						select
						InputProps={{
							style: {color: theme.palette.primary.darkMain}
						}}
                        value={filterFutureOnly}
                        onChange={(e) => extraFilterFutureOnly(e.target.value)}
					>
                        <MenuItem value="NO">NO</MenuItem>
                        <MenuItem value="SI">SI</MenuItem>
					</TextField>
				</div>
			</div>

			<Box sx={{ width: '100%', minWidth: '800px' }}>
				<ThemeProvider theme={theme}>
					<DataGrid
						//onRowDoubleClick={hook}
						sx={{ minHeight: '300px' }}
						rows={filteredRows}
						columns={columns}
                        getRowClassName={(params) => `${params.row.color}`}
						paginationModel={paginationModel}
						onPaginationModelChange={handlePaginationChange}
						pageSizeOptions={pageSizeOptions}
						apiRef={apiRef}
						slots={{
							toolbar: GridToolbar,
						}}
						slotProps={{
							columnsPanel: {
								disableHideAllButton: true,
							},
							toolbar: {
								showQuickFilter: true
							}
						}}
					/>
				</ThemeProvider>
			</Box>

			<Dialog
				open={displayDialog !== 0}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				{displayDialogContent && displayDialog !== -1? (
					<>
						<DialogTitle id="alert-dialog-title">
							Dettagli della scadenza
						</DialogTitle>
						<DialogContent>
							<DialogContentText id="alert-dialog-description">
								<div dangerouslySetInnerHTML={{ __html: displayDialogContent }} />
							</DialogContentText>
						</DialogContent>
					</>
				) : (
					<>
						<DialogTitle id="alert-dialog-title">
							{displayDialog === 1 && "Operazione completata"}
							{displayDialog === -1 && "Errore"}
						</DialogTitle>
						<DialogContent>
								<DialogContentText id="alert-dialog-description">
									{displayDialog === 1 && "Operazione completata con successo!"}
									{displayDialog === -1 && "Si è verificato un errore inatteso"}
								</DialogContentText>
						</DialogContent>
					</>
				)}
				<DialogActions>
					<Button onClick={handleClose}>Chiudi</Button>
				</DialogActions>
			</Dialog>

			<Dialog
                sx={{
                    "& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                            width: "100%",
                            maxWidth: "1000px",
                        },
                    },
                }}
				open={displayManagementDialogId !== null}
				onClose={handleCloseManagementDialog}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">
					Gestisci scadenza
				</DialogTitle>
				<DialogContent>
                    <AnnotationForm deadline={displayManagementDialogId} />
				</DialogContent>
				<DialogActions>
					<Button onClick={handleCloseManagementDialog}>Chiudi</Button>
				</DialogActions>
			</Dialog>
		</>
	);
}

export default Timetable;
